import { ReactNode } from 'react';
import { Box, Chip, Typography } from '@mui/material';

export default function ImportStep({ n, children }: { n: number; children: ReactNode }) {
  return (
    <Box sx={{ display: 'flex', gap: 1.25, alignItems: 'flex-start' }}>
      <Chip label={n} size="small" sx={{ minWidth: 24, height: 22, fontWeight: 600 }} />
      {/* div, not the default p: a step may nest a block-level list. */}
      <Typography variant="body2" component="div" sx={{ pt: 0.1 }}>{children}</Typography>
    </Box>
  );
}
